import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue";
const _hoisted_1 = {
  class: "space-y-3"
};
const _hoisted_2 = {
  class: "flex items-center gap-3"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "space-y-2 max-h-64 overflow-y-auto"
};
const _hoisted_5 = {
  key: 2,
  class: "flex-1 min-w-0 text-xs text-slate-400"
};
const _hoisted_6 = ["onClick"];
import { Delete } from '@element-plus/icons-vue';
import UserSelector from '@/components/UserSelector/index.vue';
import DeptSelector from '@/components/DeptSelector/index.vue';
export default {
  __name: 'AssetFolderAclEditor',
  props: {
    visibilityType: {
      type: String,
      default: 'INHERIT'
    },
    aclItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:visibilityType', 'update:aclItems'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    function onVisibilityChange(val) {
      emit('update:visibilityType', val);
      if (val === 'INHERIT') {
        emit('update:aclItems', []);
      }
    }
    function addItem() {
      emit('update:aclItems', [...props.aclItems, {
        subjectType: 'USER',
        subjectValue: [],
        permissionLevel: 'VIEW'
      }]);
    }
    function removeItem(idx) {
      emit('update:aclItems', props.aclItems.filter((_, index) => index !== idx));
    }
    function updateItem(idx, patch) {
      emit('update:aclItems', props.aclItems.map((item, index) => index === idx ? {
        ...item,
        ...patch
      } : item));
    }
    function onSubjectTypeChange(idx, subjectType) {
      updateItem(idx, {
        subjectType,
        subjectValue: []
      });
    }
    return (_ctx, _cache) => {
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("span", {
        class: "text-sm text-slate-500 shrink-0"
      }, "可见性类型：", -1)), _createVNode(_component_el_radio_group, {
        "model-value": __props.visibilityType,
        onChange: onVisibilityChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          value: "INHERIT"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("继承父级", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio, {
          value: "CUSTOM"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("自定义", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["model-value"])]), __props.visibilityType === 'CUSTOM' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
        class: "flex items-center justify-between mb-2"
      }, [_cache[3] || (_cache[3] = _createElementVNode("span", {
        class: "text-sm font-medium text-slate-600"
      }, "ACL 条目", -1)), _createElementVNode("button", {
        type: "button",
        class: "btn-primary btn-sm",
        onClick: addItem
      }, "添加")]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.aclItems, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          key: idx,
          class: "flex items-center gap-2 p-2 bg-slate-50 rounded"
        }, [_createVNode(_component_el_select, {
          "model-value": item.subjectType,
          class: "!w-28 shrink-0",
          size: "small",
          "onUpdate:modelValue": $event => onSubjectTypeChange(idx, $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "用户",
            value: "USER"
          }), _createVNode(_component_el_option, {
            label: "部门",
            value: "DEPT"
          }), _createVNode(_component_el_option, {
            label: "所有用户",
            value: "ALL_AUTHENTICATED"
          })]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue"]), item.subjectType === 'USER' ? (_openBlock(), _createBlock(UserSelector, {
          key: `user-${idx}-${item.subjectType}`,
          "model-value": item.subjectValue,
          multiple: true,
          placeholder: "选择用户",
          class: "flex-1 min-w-0 max-w-full",
          "onUpdate:modelValue": $event => updateItem(idx, {
            subjectValue: $event
          })
        }, null, 8, ["model-value", "onUpdate:modelValue"])) : item.subjectType === 'DEPT' ? (_openBlock(), _createBlock(DeptSelector, {
          key: `dept-${idx}-${item.subjectType}`,
          "model-value": item.subjectValue,
          multiple: true,
          placeholder: "选择部门",
          class: "flex-1 min-w-0 max-w-full",
          "onUpdate:modelValue": $event => updateItem(idx, {
            subjectValue: $event
          })
        }, null, 8, ["model-value", "onUpdate:modelValue"])) : (_openBlock(), _createElementBlock("span", _hoisted_5, "所有认证用户")), _createVNode(_component_el_select, {
          "model-value": item.permissionLevel,
          class: "!w-24 shrink-0",
          size: "small",
          "onUpdate:modelValue": $event => updateItem(idx, {
            permissionLevel: $event
          })
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "查看",
            value: "VIEW"
          }), _createVNode(_component_el_option, {
            label: "管理",
            value: "MANAGE"
          })]),
          _: 1
        }, 8, ["model-value", "onUpdate:modelValue"]), _createElementVNode("button", {
          type: "button",
          class: "btn-icon-danger shrink-0",
          title: "删除",
          onClick: $event => removeItem(idx)
        }, [_createVNode(_component_el_icon, {
          size: 14
        }, {
          default: _withCtx(() => [_createVNode(_unref(Delete))]),
          _: 1
        })], 8, _hoisted_6)]);
      }), 128))])])) : _createCommentVNode("", true)]);
    };
  }
};